"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

exports.Item = function (_a) {
  var children = _a.children,
      className = _a.className,
      id = _a.id,
      value = _a.value;
  return React.createElement("li", {
    className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "listItem", className]),
    id: id,
    value: value
  }, children);
};

exports.Item.displayName = "List.Item";